<nb-card *ngIf="!showPlain">
    <nb-card-header *ngIf="!headerHide">
        <ng-container *ngIf="!additionalBlock || !(additionalBlock.enable | async)">
            <div [ngClass]="!subTitle ? 'singleTitle': ''">
                <div class="primary-header">{{title}}</div>
                <div *ngIf="subTitle" class="sub-header">{{subTitle}}</div>
            </div>
        </ng-container>

        <div *ngIf="additionalBlock && additionalBlock.enable | async" class="d-flex align-items-center">
            <button
                nbButton
                class="mr-3"
                (click)="additionalBlock?.toggleCallback(); additionalBlockDropdown && additionalBlockDropdownControl.reset()"
            >
                <nb-icon [icon]="'close-outline'"></nb-icon>
            </button>

            <div *ngIf="additionalBlockTitle | async" class="mr-3 sub-header">{{additionalBlockTitle | async}}</div>

            <div *ngFor="let button of additionalBlockButtons">
                <button
                    [disabled]="!(button.enable | async)"
                    nbButton
                    status="control"
                    class="mr-2 additional-block-btn"
                    (click)="button?.callback()"
                >
                    <nb-icon *ngIf="button?.icon" [icon]="button?.icon" [pack]="button?.pack || 'eva'"></nb-icon>
                    <span *ngIf="button?.label">{{ button?.label }}</span>
                </button>
            </div>

            <div *ngIf="additionalBlockDropdown">
                <div class="d-flex align-items-center">
                    <nb-select [formControl]="additionalBlockDropdownControl">
                        <nb-option *ngFor="let option of additionalBlockDropdown.optionsList$ | async" [value]="option">
                            {{ option.label }}
                        </nb-option>
                    </nb-select>

                    <button
                        nbButton
                        class="ml-3"
                        (click)="additionalBlockDropdown.callback(additionalBlockDropdownControl.value); additionalBlockDropdownControl.reset()"
                    >
                        <nb-icon [icon]="'checkmark-outline'"></nb-icon>
                    </button>
                </div>
            </div>

            <ngx-nested-select-dropdown
                *ngIf="nestedSelectDropdown"
                [config]="nestedSelectDropdown"
            ></ngx-nested-select-dropdown>
        </div>

        <div class="display-flex">
            <!-- Global search -->
            <input
                *ngIf="enableGlobalSearch()"
                nbInput
                #search
                type="text"
                placeholder="Search..."
                (blur)="onSearch(search.value)"
            />

            <!-- Custom header buttons; either header buttons, or select action buttons -->
            <div class="header-side-container">
                <div *ngIf="selectColumnBtn?.enable" class="col-1 header-select-columns-button">
                    <ngx-button-multiselect
                        *ngIf="(selectColumnBtn.columns$ |async)?.length"
                        [formControl]="_selectedColumnsControl"
                        [iconDetails]="{icon: 'layout-outline'}"
                        [options$]="selectColumnBtn.columns$"
                        defaultGroupTitle="Columns"
                    ></ngx-button-multiselect>
                </div>

                <ng-container *ngIf="customButton && customButton.length > 0">
                    <div *ngFor="let _customButton of customButton">
                        <div *ngIf="_customButton?.enabled" class="ml-2">
                            <button
                                nbButton
                                [status]="_customButton?.status || 'basic'"
                                (click)="_customButton?.callback()"
                            >
                                <nb-icon
                                    *ngIf="_customButton?.icon"
                                    [icon]="_customButton?.icon"
                                    [pack]="_customButton?.pack || 'eva'"
                                ></nb-icon>
                                {{ _customButton.label }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Pagination display; has vertical separator/border line -->
            <form class="header-simple-pager" [formGroup]="pagingFormGroup" *ngIf="enablePagePerRecord()">
                <label class="simple-pager-label">Records on page</label>
                <input
                    nbInput
                    formControlName="perPage"
                    type="number"
                    [min]="1"
                    [max]="99"
                    [ngxOnlyNumber]
                    strict="true"
                    placeholder="Rows"
                    class="simple-pager-input"
                />
            </form>

            <!-- TODO: this never shows up ? -->
            <div class="vertical-separator" *ngIf="enablePagePerRecord()"></div>
            <!-- Common table actions: refresh button, table settings -->
            <div class="header-side-container">
                <div *ngIf="enableTableRefresh()" class="col-1 header-refresh-button">
                    <button (click)="refresh()" [disabled]="disableRefresh" nbButton>
                        <nb-icon [pack]="'eva'" class="icon" icon="refresh"></nb-icon>
                    </button>
                </div>

                <div *ngIf="enableTableSetting()" class="col-1 header-setting-button">
                    <ngx-table-settings
                        (downloadFile)="onDownload()"
                        (downloadBulkFiles)="onBulkDownload($event)"
                        [disableDataDownload]="emptyData"
                        [customCsvDownloadMenu]="enableCustomCsvDownloadMenu()"
                    ></ngx-table-settings>
                </div>
            </div>
        </div>
    </nb-card-header>

    <nb-card-body>
        <ngx-smart-table
            [settings]="settings"
            [source]="data"
            (custom)="onCustomEventClick($event)"
            (onFilter)="onFilter($event)"
            (rowSelect)="onRowSelect($event)"
            (userRowSelect)="onUserRowSelect($event)"
        ></ngx-smart-table>
    </nb-card-body>
</nb-card>

<ngx-smart-table
    *ngIf="showPlain"
    [settings]="settings"
    [source]="data"
    (custom)="onCustomEventClick($event)"
    (onFilter)="onFilter($event)"
    (rowSelect)="onRowSelect($event)"
    (userRowSelect)="onUserRowSelect($event)"
></ngx-smart-table>
